import { Trophy, Medal } from 'lucide-react';

interface TrophyItem {
  id: string;
  tournamentName: string;
  position: 'champion' | 'runner-up' | 'third';
  season?: string;
}

interface TrophyShowcaseProps {
  trophies: TrophyItem[];
}

const positionConfig = {
  champion: { icon: '🏆', label: 'Champion', color: 'text-gold' },
  'runner-up': { icon: '🥈', label: 'Runner-up', color: 'text-muted-foreground' },
  third: { icon: '🥉', label: '3rd Place', color: 'text-warning' },
};

export function TrophyShowcase({ trophies }: TrophyShowcaseProps) {
  if (!trophies || trophies.length === 0) return null;

  return (
    <section className="py-6 overflow-hidden">
      <div className="container">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 rounded-xl bg-gold/10">
            <Trophy className="h-5 w-5 text-gold" />
          </div>
          <h2 className="font-display text-lg text-foreground">Trophy Cabinet</h2>
        </div>
        
        <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-border">
          {trophies.map((trophy) => {
            const config = positionConfig[trophy.position];
            return (
              <div 
                key={trophy.id}
                className="flex-shrink-0 flex items-center gap-3 px-4 py-3 rounded-xl bg-card/80 border border-border/50 hover:border-gold/30 transition-colors"
              >
                <span className="text-2xl">{config.icon}</span>
                <div>
                  <div className={`font-medium text-sm ${config.color}`}>{trophy.tournamentName}</div>
                  <div className="text-xs text-muted-foreground">{config.label} {trophy.season && `• ${trophy.season}`}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
